import { useUser } from "../../context/UserContext";
import { useNavigate } from "react-router-dom";
import { useLogoutFromThisDevice } from "../../api/auth/logoutapi";
import toast from "react-hot-toast";

const LogoutPop = ({ show, setShow, device, logoutType }) => {
    const { logout } = useUser();
    const { mutate: logoutFromThisDevice, isPending } = useLogoutFromThisDevice();
    const navigate = useNavigate();

    const handleLogout = () => {
        logoutFromThisDevice(logoutType, {
            onSuccess: (data) => {
                if (data?.success === true && logoutType === "current") {
                    logout();
                    navigate("/");
                    setShow(false);


                }
                if (data?.success === true && logoutType === "others") {
                    setShow(false);
                    console.log(data)
                    toast.success(data?.message)


                }
            }
        });

    };
    if (!show) return null;

    return (
        <div className="fixed inset-0 z-[2000] flex items-center justify-center bg-black bg-opacity-40 h-screen backdrop-blur-[5px]">
            <div className="max-w-sm w-full mx-auto relative p-6 mb-5 bg-[#044572]  rounded-2xl shadow-[0_4px_30px_rgba(0,0,0,0.1)] backdrop-blur-[150px] border border-[rgba(255,255,255,0.3)]"
            >
                <p className="font-semibold mb-4">
                    Are you sure you want to log out from <i className="">{device}</i>?
                </p>
                <div className="flex justify-center gap-4">
                    {isPending ?
                     <span
                            className="bg-red-600 text-white px-4 py-2 rounded"
                        >
                            Logout....
                        </span>
                         :
                        <button
                            onClick={handleLogout}
                            className="bg-red-600 text-white px-4 py-2 rounded"
                        >
                            Logout
                        </button>
                    }
                    <button
                        onClick={() => setShow(false)}
                        className="bg-gray-300 text-black px-4 py-2 rounded"
                    >
                        Cancel
                    </button>
                </div>
            </div>
        </div>
    );
};

export default LogoutPop;
